module.exports = __webpack_public_path__ + "img/26.2dd6aaa3.jpg";